<template>
  <div>
    <van-form class="q_mar_b100px">
      <van-field name="uploader" label="身份证正面" input-align="right">
        <template #input>
          <van-uploader v-model="idCardA" :max-count="1" :after-read="afterRead"/>
        </template>
      </van-field>
      <van-field name="uploader" label="身份证反面" input-align="right">
        <template #input>
          <van-uploader v-model="idCardB" :max-count="1" :after-read="afterRead1"/>
        </template>
      </van-field>
<!--      <van-cell title="手机号码">-->
<!--        <template>-->
<!--          <span class="q_color_black" v-text="phone">15326352154</span>-->
<!--          <van-button plain round type="primary" size="mini" color="#FF5733" @click="sendCode" :disabled="isSendCode"-->
<!--          >{{ codeText }}-->
<!--          </van-button>-->
<!--        </template>-->
<!--      </van-cell>-->
<!--      <van-field v-model="code" clearable label="手机验证码" placeholder="请输入手机验证码" input-align="right"/>-->
    </van-form>
    <van-goods-action v-show="isOriginHei">
      <van-goods-action-button type="danger" color="#FF5733" text="确认提交" @click="submitForm()" :loading="buttonLoading"
                               :disabled="buttonLoading"/>
    </van-goods-action>
  </div>
</template>

<script>
import {getToken} from "@/utils/auth";
import axios from "axios";
import {baseUrl, isRelogin} from "@/utils/request";
import {Dialog} from "vant";
import store from "@/store";
import {getCode} from "@/api/login";
import {updateIdCardInfo} from "@/api/user";
import {wxCloseShare} from "@/utils/jiutang";

export default {
  name: 'Identity',
  props: {
    msg: String
  },
  data() {
    return {
      originHeight: 0, 	// 原始高度
      screenHeight: 0, 	// 实际高度
      isOriginHei: true, 	// 显示或隐藏底部信息
      idCardA: [],
      idCardB: [],
      phone: '',
      code: '',
      //发送验证码是否显示
      isSendCode: false,
      //验证码重新发送秒
      second: 120,
      //验证码显示文本
      codeText: '发送验证码',
      buttonLoading: false,
      user: {}
    }
  },
  created() {
    wxCloseShare()
    this.$modal.loading('加载个人信息')
    this.$store.dispatch("GetInfo").then(res => {
      this.user = res.data
      this.phone = res.data.phone
      this.reset()
    }).finally(() => {
      this.$modal.closeLoading()
    })
  },
  methods: {
    watchResize() {
      //实时变化的窗口高度
      this.screenHeight = document.documentElement.clientHeight;
    },
    /**
     * 提交身份证认证
     */
    submitForm() {
      if (this.idCardA.length == 0) {
        this.$modal.alert('请上传身份证正面')
        return
      }
      if (this.idCardB.length == 0) {
        this.$modal.alert('请上传身份证反面')
        return
      }
      // if (!this.code) {
      //   this.$modal.alert('请输入手机验证码')
      //   return
      // }

      let data = {
        'id': this.user.id,
        'idCardA': this.idCardA[0].url,
        'idCardB': this.idCardB[0].url,
        'phone': this.phone,
        'code': this.code
      }

      this.buttonLoading = true
      //修改基本资料
      this.$modal.loading("正在保存")
      updateIdCardInfo(data).then(res => {
        this.buttonLoading = false
        this.$store.dispatch("GetInfo")
        this.$modal.success("保存成功")
        setTimeout(() => {
          this.$modal.closeLoading()
          this.$router.push({
            path: '/mine'
          });
        }, 1500);
      }).catch(() => {
        this.buttonLoading = false
        this.$modal.closeLoading()
      })

    },
    /**
     * 表单初始化
     */
    reset() {
      if (this.user.idCardA && null != this.user.idCardA) {
        this.idCardA = [{'url': this.user.idCardA}]
      }
      if (this.user.idCardB && null != this.user.idCardB) {
        this.idCardB = [{'url': this.user.idCardB}]
      }
    },
    /**
     * 发送验证码
     */
    sendCode() {
      //发送验证码
      this.isSendCode = true
      let data = {'phone': this.phone, 'type': '2'}
      this.$modal.loading('正在发送')
      getCode(data).then(res => {
        this.$modal.closeLoading()
        this.$modal.success("发送成功")
        let second = this.second
        let timer = setInterval(() => {
          second--
          this.timeFun(second, timer)
        }, 1000)
      }).catch(() => {
        this.$modal.closeLoading()
        this.isSendCode = false
      })
    },
    /**
     * 倒计时
     * @param timer
     */
    timeFun(second, timer) {
      setTimeout(() => {
        if (second != 0) {
          this.isSendCode = true
          this.codeText = second + '秒后重试'
        } else {
          this.isSendCode = false
          this.codeText = '发送验证码'
          clearInterval(timer)
        }
      }, 0)
    },
    /**
     * 文件上传
     */
    afterRead(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      let param = new FormData();
      param.append('file', file.file);//通过append向form对象添加数据
      let config = {
        headers: {'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + getToken()}
      };
      //添加请求头
      axios.post(baseUrl + "/h5/common/upload", param, config).then(res => {
        if (res.data.code == 401) {
          Dialog.confirm({
            title: '提示', message: '登录状态已过期，您可以继续留在该页面，或者重新登录', confirmButtonText: '重新登录', cancelButtonText: '取消'
          }).then(() => {
            isRelogin.show = false
            store.dispatch('LogOut').then(() => {
              location.href = '/h5/mine/sign'
              // location.href = '/mine/sign'
            })
          }).catch(() => {
            isRelogin.show = false
          });
        } else if (res.data.code == 500) {
          this.$modal.alert('上传失败，请重新上传')
          file.status = 'failed';
          file.message = '上传失败';
        } else {
          file.status = '';
          file.message = '';
          let pic = {'url': res.data.url}
          this.idCardA = [pic]
        }
      })
    },
    /**
     * 文件上传
     */
    afterRead1(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      let param = new FormData();
      param.append('file', file.file);//通过append向form对象添加数据
      let config = {
        headers: {'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + getToken()}
      };
      //添加请求头
      axios.post(baseUrl + "/h5/common/upload", param, config).then(res => {
        if (res.data.code == 401) {
          Dialog.confirm({
            title: '提示', message: '登录状态已过期，您可以继续留在该页面，或者重新登录', confirmButtonText: '重新登录', cancelButtonText: '取消'
          }).then(() => {
            isRelogin.show = false
            store.dispatch('LogOut').then(() => {
              location.href = '/h5/mine/sign'
              // location.href = '/mine/sign'
            })
          }).catch(() => {
            isRelogin.show = false
          });
        } else if (res.data.code == 500) {
          this.$modal.alert('上传失败，请重新上传')
          file.status = 'failed';
          file.message = '上传失败';
        } else {
          file.status = '';
          file.message = '';
          let pic = {'url': res.data.url}
          this.idCardB = [pic]
        }
      })
    },
    goToFeedback() {
      this.$router.push({
        path: '/activity/Feedback'
      });
    },
  },
  mounted () {
    //首次进入的原始高度
    this.originalHeight = document.documentElement.clientHeight;
    //监听屏幕变化并获取到屏幕原始高度
    window.addEventListener('resize', this.watchResize);

  },
  beforeDestroy() {			//删除对resize的监听变化
    window.removeEventListener("resize", this.watchResize);
  },
  watch:{
    screenHeight(newHeight) { //监听屏幕高度变化
      this.isOriginHei = this.originalHeight <= newHeight;
    }
  },
}
</script>
<style scoped="scoped">
>>> .van-goods-action-button--last {
  margin-right: 80px;
}

.van-goods-action-button--first {
  margin-left: 80px;
}

.van-goods-action {
  box-shadow: 0 0 10px #f2f3f7;
  height: 60px;
}

.van-button--mini {
  margin-left: 5px;
  float: right;
}
</style>
